// /family-tree — a placeholder, and deliberately an honest one.
//
// The tree layer does NOT exist yet. `sql/schema.sql` says so where the address
// book tables end: forests, tree_persons and tree_relations are designed in
// `docs/plan-address-book.md` but not created, because their merge and
// de-duplication rules are still open.
//
// So this page exists to hold the nav position and say what is coming, rather
// than to imply a feature that would 500 the moment anyone clicked it. When the
// tables land, this file is where the real view goes.
//
// What is already decided and must not drift when it is built (all from the same
// doc, section "The family graph"):
//
//   - Tree nodes ARE contacts. One person, one row. Not a second database.
//   - Relationship LABELS are computed by walking parent edges from the current
//     root, never stored. Re-rooting on anyone recomputes every label, which is
//     why arbitrary depth needs no special casing. Never add an `uncle` kind or
//     a denormalised label column.
//   - Only two edge kinds, `parent` and `spouse`, each carrying a blood/affinity
//     flag. "Bloodline Only" is then a WHERE clause on edge kind, not a second
//     traversal — which is what keeps a blood descendant on screen when the
//     step-parent she descends through is filtered out.
//   - A shared ancestor is ONE record with an audit trail, not two synced copies.
//     Facts (names, dates) merge with history; contributions (photos, documents,
//     memories) are append-only and attributed, and never overwrite each other.

import { el } from '../dom.js';
import type { View } from '../router.js';

export const familyTreeView: View = (outlet) => {
  outlet.append(
    el('main', { class: 'page' }, [
      el('h1', {}, 'Family tree'),
      el(
        'p',
        { class: 'muted' },
        'Not built yet. The tree will be drawn over your address book, so everyone '
        + 'in it is a contact you already have rather than a second list to maintain.',
      ),
      el(
        'p',
        { class: 'muted' },
        'The point of building it here rather than in a genealogy app: a family '
        + 'maintains it together. You hold one branch, a relative holds another.',
      ),
      el('p', {}, [el('a', { href: '/contacts' }, 'Go to the address book')]),
    ]),
  );
};
